import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import { useDispatch, useSelector } from 'react-redux';
import {
    Link,
    useHistory
} from "react-router-dom";
import { get_all_companies } from "../../../redux/company";

/** @module  Pages/Company/Companies */

const Companies = (props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    
    const { token } = useSelector((state) => state.users_module.login.data)||null;

    useEffect(() => {
        dispatch(get_all_companies(token));
    }, [dispatch, token]);


    const companies = useSelector(
        (state) => state.company_module._get_all_companies
    );
    const _data_login = useSelector((state) => state.users_module.login.data);
    const [data, setData] = useState([]);
    // eslint-disable-next-line
    const [login, setLogin] = useState({});
    const [permisos, setPermisos] = useState([]);
    useEffect(() => {
        if (_data_login) {
            setLogin(_data_login);
        }
        if (companies.data.datos) {
            setData(companies.data.datos);
        }
    }, [companies, _data_login]);


    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);

        }
    }, [props]);

    const [actions, setActions] = useState([]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_company').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "primary",
                    onClick: (item) => {
                        history.push({pathname: `/empresas/editar/${item.id}`, state: {data: item}});
                    },
                })
            }


        }
        setActions(act);


    }, [permisos, history]);

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Empresas"
                            items={[{label: "Empresas", link: "/empresas"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_company').length > 0 ? <Link
                                        to="/empresas/crear"
                                        className="btn btn-success"
                                    >
                                        Crear
                                    </Link> : null
                                }

                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "nombre",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "rut",
                                                label: "Rut",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha Creacion",
                                                type: "text",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Companies;
